export default __webpack_public_path__ + "static/media/operations.04a8147b.svg";